import { createSelector } from "@ngrx/store";
import { AppState } from "../index.selector";
import { AuthState } from "./auth.reducer";

export const selectFeature = (state: AppState) => state.auth;
export const selectFeatureUser = createSelector(
  selectFeature,
  (state: AuthState) => state.user,
);
